import axios from 'axios';
import { API_BASE } from './api';

const conductorApi = axios.create({
  baseURL: API_BASE,
});

conductorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('conductor_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

conductorApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem('conductor_token');
      localStorage.removeItem('conductor');
      if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default conductorApi;
